import AssessmentsIndex from './AssessmentsIndex';
import AssessmentsCreate from './AssessmentsCreate';
import AssessmentsSettings from './AssessmentsSettings';
import AssessmentsSingle from './AssessmentsSingle';

export default function (app) {

    const settings = AssessmentsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    AssessmentsIndex(app, settings);

    AssessmentsCreate(app, settings);

    AssessmentsSingle(app, settings);

}